/*
 *   Copyright (c) 2022 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 *   See License in the LICENSE file
 */
import { Link } from "gatsby";
import * as React from "react";
import Layout from "../components/layout";
import "../styles/suggests.scss";

interface IData {
  url?: string;
  message?: string;
  email?: string;
}

const SuggestPage = ({ pageContext, location }: any) => {
  const [data, setData] = React.useState<IData>({});
  const [success, setSuccess] = React.useState(false);

  function handleInput(
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const target = event.currentTarget;
    const value = target.value;
    const name = target.name;
    setData({
      ...data,
      [name]: value,
    });
  }

  function submit(event: React.SyntheticEvent) {
    event.preventDefault();
    fetch(`${process.env.GATSBY_SUGGEST_POST_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data,
      }),
    })
      .then((resp) => {
        if (resp.ok) {
          setSuccess(true);
          return;
        }
        setSuccess(false);
      })
      .catch((reason) => {
        setSuccess(false);
      });
  }

  return (
    <Layout
      pageTitle="FIT - Contribute"
      pageContext={pageContext}
      location={location}
      type="contribute"
    >
      <div className="breadcrumb p-0">
        <a
          href="https://www.fairnessinteaching-project.eu"
          className="hover:underline hover:decoration-primary"
        >
          {"Back to Home Page"}
        </a>
      </div>

      {!success ? (
        <>
          <h1 className="underline decoration-primary underline-offset-8 mb-12">
            Share your ideas and materials
          </h1>
          <div className="w-full">
            <p className="my-4">
              You have ideas of materials or activities to develop? <br />
              You have developed your own fair teaching materials? <br />
              You know some resources that would be useful to improve the
              fairness of teaching ?
            </p>
            <p className="my-4 font-bold">
              By sharing them with the community of fair teachers, you help
              making teaching fairer !
            </p>
            <form method="post" onSubmit={submit}>
              <div className="mainform flex flex-col my-4">
                <label>
                  Short description
                  <textarea
                    name="message"
                    id="message"
                    rows={10}
                    required
                    placeholder="Please describe your idea, practice or resource:
Tell us what  type of activity or material it is, which is its language, if it is adapted to a specific STEM discipline or how a teacher can use it.
If it is available online, you can also write its URL hereunder."
                    onChange={handleInput}
                  />
                </label>
                <label>
                  Content link (if applicable)
                  <input
                    type="url"
                    name="url"
                    id="url"
                    placeholder=""
                    onChange={handleInput}
                  />
                </label>
                <p className="my-4">
                  If you want to get news from the community of fair teachers,
                  write your e-mail address !
                </p>
                <label>
                  Contact email
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder=""
                    onChange={handleInput}
                  />
                </label>
              </div>
              <div className="flex flex-col">
                <label className="mx-auto">
                  I have read and accept the{" "}
                  <a href="https://www.fairnessinteaching-project.eu/privacy-policy">
                    terms applicable
                  </a>{" "}
                  when submitting new content to the FIT consortium:
                  <input
                    className="mx-2"
                    type="checkbox"
                    name="consent"
                    id="consent"
                    required
                  />
                </label>
                <button
                  className="flex rounded-xl p-4 w-32 justify-center bg-green hover:bg-opacity-95 shadow-md text-lightgray mx-auto mt-8"
                  type="submit"
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </>
      ) : (
        <div className="w-full">
          <h1 className="mb-12">Thank you for sharing !</h1>
          <p className="my-4">
            By contributing to the FIT platform, you help making teaching
            fairer. We will be in touch soon.
          </p>
          <p className="my-4">
            In the meantime, feel free to explore our existing contents:
          </p>
          <Link to="/">
            <button
              className="flex rounded-xl p-4 justify-center bg-primary hover:bg-opacity-95 shadow-md text-lightgray mx-auto mt-8"
              type="submit"
            >
              Explore our existing contents
            </button>
          </Link>
        </div>
      )}
    </Layout>
  );
};

export default SuggestPage;
